<template>
  <b-container fluid>
    <page-title icon="fas fa-users">
      <translate>Users</translate>
      <template #extras>
        <div v-if="ecosystem.product !== 'carriers'">
          <b-button variant="secondary" size="sm" @click="newUserType = null" v-b-modal.modalNewUser>
            <font-awesome-icon icon="plus-circle" />
            <translate>New User</translate>
          </b-button>
          <b-button variant="secondary" size="sm" @click="newUserType = 'courier'" v-b-modal.modalNewUser>
            <font-awesome-icon icon="plus-circle" />
            <translate>New Courier</translate>
          </b-button>
        </div>
        <div v-else>
          <b-button variant="secondary" size="sm" @click="newUserType = 'gcm-admin'" v-b-modal.modalNewUser>
            <font-awesome-icon icon="plus-circle" />
            <translate>New Admin</translate>
          </b-button>
          <b-button variant="secondary" size="sm" @click="newUserType = 'courier'" v-b-modal.modalNewUser>
            <font-awesome-icon icon="plus-circle" />
            <translate>New Courier</translate>
          </b-button>
        </div>
      </template>
    </page-title>
    <api-list type="users" :model="models.users" :quick-filters="quickFiltersSetup.users" />
    <b-modal size="md" id="modalNewUser" ref="modalNewUser" hide-footer>
      <template #modal-title>
        <span v-if="newUserType === null" v-translate>Create New User</span>
        <span v-else v-translate="{roleName: userTypeComputed}">Create New %{roleName}</span>
      </template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <users-create :user-type="newUserType" @success="$refs.modalNewUser.hide()" @cancel="$refs.modalNewUser.hide()" />
    </b-modal>
  </b-container>
</template>
<script>
import ApiList from '@/components/ApiLists/ApiList'
import UsersCreate from '@/components/Users/Create'

export default {
  name: 'UsersList',
  title() {
    return this.$gettext('Users')
  },
  components: {
    ApiList,
    UsersCreate
  },
  computed: {
    userTypeComputed() {
      return this.$gettext(this.newUserType)
    }
  },
  data() {
    return {
      newUserType: 'normal'
    }
  }
}
</script>
